<template lang='pug'>
  .orders.calendar.component( v-if='!rsv' )
    vue-cal.cal.vuecal--blue-theme.calendar(
      default-view="week"
      small
      :time-step='30'
      :disable-views="['years', 'year']"
      :selected-date="new Date()"
      :time-from='0 * 60'
      :time-to='24 * 60'
      :events="events"
      :on-event-click='view' 
      @view-change='vchange'
      @ready='scrollToNow'
      style="height: 750px"
    )

  bf-overlay( v-else @close='rsv = false' )
    h5.section-heading( v-if='rsv.class == "custom"' ) {{ $t('Custom Event') }}
    h5.section-heading( v-else ) {{ $t('Reservation/Appointment Details') }}

    rsv-dtls.overlay(
      v-if='rsv'
      :rsv='rsv'
      :options='{ show: { biz: rsv.class == "customer", cus: rsv.class == "merchant" } }'
    )

    rsv-msgs#rsv-msgs(
      v-if='rsv && account'
      :rsv='rsv'
      :account='account'
      :key='rsv.id'
    )
</template>

<script>
  import { db } from '@/main'
  import VueCal from 'vue-cal'

  export default {
    name: 'orders.calendar.component',

    components: {
      VueCal
    },

    props: {
      user: Object,
      account: [ Object, Array ],
      biz: [ Object, Array ],
      orders: [ Array ]
    },

    data() {
      return {
        rsv: false,
        rsvs: [],
        evts: [],
        perspective: 'week',
        mapper: {
          mon: 1,
          tue: 2,
          wed: 3,
          thu: 4,
          fri: 5,
          sat: 6,
          sun: 7
        }
      }
    },

    computed: {
      hide() {
        let days = []
        Object.keys( this.biz.cfg.days ).forEach( key  =>  {
          if ( !this.biz.cfg.days[key] ) days.push( this.mapper[key] )
        })
        return days
      },

      opening() {
        if ( !this.biz.cfg || !this.biz.cfg.opening ) return 8 * 60
        let d = new Date(this.biz.cfg.opening)
        let mins = d.getUTCHours() * 60 + d.getUTCMinutes()
        return mins
      },

      closing() {
        if ( !this.biz.cfg || !this.biz.cfg.closing ) return 20 * 60
        let d = new Date(this.biz.cfg.closing)
        let mins = d.getUTCHours() * 60 + d.getUTCMinutes()
        return mins
      },

      events() {
        return this.orders.map( o => ({...o, ...{
          startDate: o.datetime.start.toDate(),
          endDate: o.datetime.end.toDate(),
          class: this.klass(o),
          content: '<img src="/ui/orders-w.svg" width="20">'
        }}))
      }
    },

    methods: {
      vchange( e ) {
        let { view } = e
        this.perspective = view
      },

      scrollToNow() {
        const calendar = document.querySelector('.vuecal__bg')
        const today = new Date()
        const hours = today.getHours()*60+120
        calendar.scrollTo({ top: hours, behavior: 'smooth' })
      },

      klass( evt ) {
        let styles = ''

        if ( evt.datetime.end.toDate() > new Date() ) {
          if ( evt.account_id == this.account.id ) styles += 'customer'
          if ( this.biz.id == evt.business_id ) styles += 'merchant'
          if ( evt.status == 'Pending Cancellation' ) styles += ' pending'
          if ( evt.status == 'Canceled' ) styles += ' canceled'
          if ( evt.name ) styles = 'custom'
        }

        return styles
      },

      view( evt ) {
        this.rsv = evt
      }
    }
  }
</script>

<style scoped lang='stylus'>
  header
    display flex
    justify-content space-between
    padding 10px 0
    @media( max-width: 560px )
      display grid
      grid-template-columns repeat( auto-fill, minmax( 70px, 1fr ) )
      grid-gap 10px 0
    .legend-item
      @media( max-width: 800px )
        display grid
        grid-template columns 1fr
        *
          text-align center
          *
            text-align center
        .container
          margin-bottom 8px
      .text
        font-weight bold
      .clr
        display inline-block
        height 24px
        width 24px
        vertical-align middle
        margin-right 12px
        &.non
          background rgb( 200 200 200 )
        &.serv
          background rgba( 255 255 0 0.8)
        &.cus
          background orange
          .cus2
            margin-left 2px
            margin-top 2px
        &.mer
          background green
          .mer2
            margin-left 2px
            margin-top 2px
        &.can-cus
          background rgb( 250 215 165 )
        &.can-mer
          background rgb( 160 210 175 )
  .section-heading
    padding 4px 8px 8px 8px

  >>> .business-hours {
    background-color: rgba(255, 255, 0, 0.2)
    border: solid rgba(255, 210, 0, 0.6)
    border-width: 2px 0
  }
  .rsv-cal
    height 720px
    @media( max-width: 560px )
      height 440px
    .cal
      margin-top 16px

  >>> .vuecal__event
    background rgb( 225 225 225 )
    height 100%
    cursor pointer

  >>> .closure
    background repeating-linear-gradient(45deg, transparent, transparent 10px, #dddddd 10px, #dddddd 20px)
    .vuecal__event-time, .vuecal__event-title
      display none

  >>> .customer
    background orange
    color white

  >>> .merchant
    background green
    color white
    height 100%

  >>> .custom
    background gray
    color white

  >>> .pending
    border 1.5px solid red

  >>> .vuecal__event-time
    @media(max-width: 480px)
      display none

  >>> .canceled
    color red

    &.merchant
      background rgb( 160 210 175 )
    &.customer
      background rgb( 250 215 165 )
    .vuecal__event-title, .vuecal__event-time
      display none

    &::after
      height 100%
      display flex
      align-items center
      justify-content center
      content 'Canceled'
      transform rotate( -15deg )
    
  >>> .vuecal__flex.vuecal__title, >>> .vuecal__flex.weekday-label
    font-weight bold
  
  >>> .vuecal--week-view, >>> .vuecal--month-view, >>> .vuecal--day-view 
    border 2px solid grey
    border-radius 5px
    background rgb(250 250 250)
  
  >>> .vuecal__cell.selected
    background rgb(120 120 244)
  >>> .weekday-label
    font-weight bold
  >>> .vuecal__heading.today
    font-weight bold
    background rgb(54 131 149)
    color white
  
  >>> .vuecal__cell--today 
    background rgba(255 255 255 .9)
    
  >>> .vuecal__cell.today
    background rgb(54 131 149)
    color orange
  >>> .vuecal__cells.month-view
    font-size 1.3em
  >>> .vuecal__time-column
    font-weight bold
    background rgb(54 131 149)
  >>> .vuecal__time-cell
    color white
  >>> .vuecal--month-view
    height 450px
  >>> .vuecal--month-view.today
    color orange
  >>>  .vuecal__cell-events-count
    background orange 

  >>> .vuecal__cell-events
    // background gray
    // height 100%
    // color blue
  >>> .vuecal__now-line
    color orange
    border-top: 3px solid
</style>
